const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const key = (uid) => `ais_assistant_session_${uid || "x"}`;

export const newSessionId = (uid) => {
  const id = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
  localStorage.setItem(key(uid), id);
  return id;
};

export const getSessionId = (uid) => localStorage.getItem(key(uid)) || newSessionId(uid);

// Akışlı cevap: her parça onDelta ile gelir, bitince { support, remaining } döner.
export async function streamChat({ sessionId, message, page, onDelta }) {
  const res = await fetch(`${API}/assistant/chat`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
    body: JSON.stringify({ session_id: sessionId, message, page }),
  });
  if (!res.ok) {
    let detail = "Cevap alınamadı, lütfen tekrar deneyin.";
    try { detail = (await res.json()).detail || detail; } catch { /* boş */ }
    throw new Error(detail);
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  let end = { support: false, remaining: null };
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const chunks = buf.split("\n\n");
    buf = chunks.pop();
    for (const c of chunks) {
      if (!c.startsWith("data: ")) continue;
      const ev = JSON.parse(c.slice(6));
      if (ev.t) onDelta(ev.t);
      if (ev.done) end = ev;
    }
  }
  return end;
}

export const PAGE_TIPS = {
  "/": ["Ana sayfadaki fırsat rozetleri ne anlama geliyor?", "Bu ay kaç poliçem yenilenecek?"],
  "/policies": ["PDF'ten poliçe nasıl eklerim?", "Satıştan iptal nasıl yapılır?"],
  "/customers": ["Müşteri birleştirme nasıl çalışır?", "Müşteri kartında neler var?"],
  "/muhasebe": ["Borç süresi nasıl hesaplanıyor?", "En uzun süredir borçlu müşterim kim?"],
  "/hakedis": ["Net Komisyon nasıl hesaplanıyor?", "Bu ay Net Komisyonum ne kadar?"],
  "/reports": ["Raporlar ile Hakediş neden farklı görünüyor?", "Bu yıl Toplam Üretimim ne kadar?"],
  "/data-entry": ["Excel ile toplu poliçe nasıl yüklerim?", "Yanlış yüklemeyi nasıl geri alırım?"],
  "/settings": ["Komisyon oranlarını nereden ayarlarım?", "Benzer şirket adlarını nasıl birleştiririm?"],
  "/archive": ["Silinen poliçeyi nasıl geri alırım?"],
  "/prospects": ["Potansiyel müşteri nasıl eklenir?"],
};
export const DEFAULT_TIPS = ["Program hakkında ne sorabilirim?", "Dijital Cüzdan nedir?"];
